import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios, { API } from "@/lib/apiClient";

export const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const navigate = useNavigate();
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          setTimeout(() => {
            if (data.kind === "account_subscription") navigate("/settings");
            else if (data.package_id === "agency") navigate(`/booking/${data.audit_id}`);
            else navigate(`/audit/${data.audit_id}`);
          }, 1500);
          return;
        }
      } catch (e) {}
      if (attempts < 15) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId, navigate]);

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-6 text-center" data-testid="payment-success-page">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-truth-green border-t-transparent" />
      <h1 className="font-heading text-2xl font-bold text-white">
        {status === "paid" ? "Payment confirmed! Redirecting..." : "Confirming your payment..."}
      </h1>
      {status === "timeout" && <p className="text-sm text-slate-500">This is taking longer than usual. Refresh in a moment.</p>}
    </div>
  );
};
